// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"gallery-module--imageWrapper--2bI3m","imageContainer":"gallery-module--imageContainer--caPkM","image":"gallery-module--image--2xjOT"};